'use client';

import type { FaqStoryblok } from '@utils/storyblok/storyblok';
import { storyblokEditable } from '@utils/storyblok/storyblokEditable';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@common/interaction/Accordion';
import { RichText } from '@common/typography/RichText';

export function Faq(props: FaqStoryblok) {
  const { items } = props;
  if (!items) return null;

  return (
    <Accordion
      type="multiple"
      {...storyblokEditable(props)}
    >
      {items.map((item) => (
        <AccordionItem
          key={item._uid}
          value={item._uid}
        >
          <AccordionTrigger className="cursor-pointer">{item.question}</AccordionTrigger>
          <AccordionContent>
            <RichText text={item.answer} />
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}
